// @flow

import React from 'react'

import {
  Edit,
  SimpleForm,
  TextInput,
  SelectInput,
  SelectArrayInput,
} from 'react-admin'
import {
  GENERAL_CATEGORIES,
  BENEFIT_TYPES,
  GENERAL_STATES,
} from '../../constants'

const BenefitEdit = props => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="name" />
      <TextInput source="description" />
      <TextInput source="link" />

      <SelectArrayInput choices={GENERAL_CATEGORIES} source="categories" />
      <SelectArrayInput choices={BENEFIT_TYPES} source="types" />

      <SelectInput choices={GENERAL_STATES} source="state" />

      <TextInput source="createdBy" />

      {/* <TextInput source="id" /> */}
    </SimpleForm>
  </Edit>
)

export default BenefitEdit
